import { useEffect, useState, type ReactNode } from 'react'
import i18n from './index'
import { LocaleContext } from './Link'
import { getLocale } from './locales'

/**
 * Activates a language for the public site: loads its resources, switches
 * i18next, sets <html lang dir>, and only renders children once the strings
 * are available so no raw keys ever flash (or get prerendered).
 */
export default function LocaleProvider({ code, children }: { code: string; children: ReactNode }) {
  const locale = getLocale(code)
  const [ready, setReady] = useState(
    i18n.language === locale.code && i18n.hasLoadedNamespace('common'),
  )

  useEffect(() => {
    let alive = true
    setReady(false)
    i18n.changeLanguage(locale.code).then(() => {
      if (alive) setReady(true)
    })
    return () => {
      alive = false
    }
  }, [locale.code])

  useEffect(() => {
    document.documentElement.lang = locale.htmlLang
    document.documentElement.dir = locale.dir
  }, [locale])

  if (!ready) return null
  return <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>
}
